import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/subWeeks/index.js';

var require$$15 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$15 as default };
